export const CATEGORIES = {
    pd: { label: 'Position description', restricted: false },
    contract: { label: 'Contract / agreement', restricted: false },
    variation: { label: 'Contract variation', restricted: false },
    offer: { label: 'Letter of offer', restricted: false },
    letter: { label: 'Letter', restricted: false },
    policy: { label: 'Policy acknowledgement', restricted: false },
    pay: { label: 'Remuneration advice', restricted: true },
    performance: { label: 'Performance record', restricted: true },
    credential: { label: 'Credential / certificate', restricted: false },
    screening: { label: 'Screening record', restricted: false },
};
/** Staff see their own documents of any category; Admin Officer cannot see pay or performance records of others. */
export function canSeeDocument(roles, category, isOwn) {
    if (isOwn)
        return true;
    if (roles.includes('Director') || roles.includes('RTOManager'))
        return true;
    if (roles.includes('AdminOfficer'))
        return !CATEGORIES[category].restricted;
    return false;
}
export function nextSigner(signers) {
    return [...signers].sort((a, b) => a.seq - b.seq).find((s) => !s.signedAt) ?? null;
}
export function documentStatus(d) {
    if (d.status === 'draft' || d.status === 'void' || d.status === 'requested' || d.status === 'pending_verify')
        return d.status;
    if (d.signers.length === 0)
        return 'filed';
    return nextSigner(d.signers) ? 'awaiting' : 'completed';
}
/** Merge {{field}} placeholders. Unknown fields are left visible so they get noticed before sending. */
export function mergeTemplate(body, fields) {
    return body.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (m, k) => {
        const v = fields[k];
        return v === undefined || v === null || v === '' ? m : String(v);
    });
}
export function missingFields(body, fields) {
    const out = new Set();
    for (const m of body.matchAll(/\{\{\s*([\w.]+)\s*\}\}/g)) {
        const k = m[1];
        if (fields[k] === undefined || fields[k] === null || fields[k] === '')
            out.add(k);
    }
    return [...out];
}
/** Typed-signature check: must match the signer's full name, ignoring case and extra spaces. */
export function typedNameMatches(typed, fullName) {
    const n = (s) => s.trim().replace(/\s+/g, ' ').toLowerCase();
    return n(typed) !== '' && n(typed) === n(fullName);
}
//# sourceMappingURL=documents.js.map